export default __webpack_public_path__ + "1839368c45c28f5394f2e8864acbea0f.ply";